import { AxiosResponse } from 'axios';
import axios from './api';
import { VersionsTextList } from './versions.types';
export const getVersions = (): Promise<AxiosResponse<VersionsTextList>> => {
  return axios.get(`/vala/admin/versions`);
};
